import styled from "styled-components";

// 모달의 버튼을 감싸는 wrapper
const ModalButtonsContainer = styled.div`
    
`

export default ModalButtonsContainer